import { service } from "@/common/axios-service";
const state = {
}

const getters={
}

const actions ={
  async GetFeaturedPrograms() {
    const response = await service.post('Market/GetFeaturedPrograms');
    if (!Array.isArray(response?.data)) throw new Error('Invalid featured programs response');
    return response.data;
  },
  async GetCategories(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Market/GetCategories?id="+form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async GetCategory(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Market/GetCategory?id="+form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async FindPackageAsync(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Market/FindPackage",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  async GetGeneralContent(context,form) {
    return new Promise((resolve,reject)=>{
      service.get("Form/GetGeneralContent?contentKey="+form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  async GetSimpleBookDetail(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Market/GetSimpleBookDetail?id="+form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  async Payment(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Payment/Internal",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  async AddMarketEvent(context,form) {
    return new Promise((resolve,reject)=>{
      service.post("Market/AddLog",form)
      .then((res) => {
        if(res && res.data)
          resolve(res.data);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
}

const mutations ={
}

export default{
    state,
    getters,
    actions,
    mutations
};
